import React from "react";
import ListJobs from "./ListJobs";


function Jobs() {
    return <ListJobs />;
}

export default Jobs;